// extracted by mini-css-extract-plugin
export default {"tile":"TemplateCard_tile__GO7St"};